import { Component } from "react";

export default class PageHeaderLeft extends Component<{ children?: React.ReactNode }> {
  public static readonly displayName = "PageHeaderLeft";

  public render() {
    return (
      <span className="mr-auto d-inline-block color-logan page-header-left">
        <small className="text-muted very-small d-print-none resource-controls">
          {this.props.children}
        </small>
      </span>
    );
  }
}
